export default __webpack_public_path__ + "static/media/avatar_3@3x.baf239bc.png";